
import { loadSectionTranslations } from '../../i18n-setup'
export default {
  name: 'SghTooltipBox',
  data() {
    return {
      showTooltipBox: false,
    }
  },
  computed: {
    isLoyaltyEnabled() {
      return sessionStorage.getItem('isLoyaltyProgramEnabled') === 'true'
    },
  },
  mounted() {
    if (this.isLoyaltyEnabled) {
    loadSectionTranslations('loyalty')
    }
  },
}
